<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
      </nav>
      <div class="copyright d-flex flex-wrap">
        &copy; Canon 2022
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style>
</style>
